import moment from "moment";

export default {
  data() {
    return {
      total: null
    };
  },
  methods: {
    //extract diff time in letters
    getDiffByTimes(to, regIn) {
      // let duration = moment.duration(moment(this.task.created_at).diff(time));
      let duration = moment.duration(moment(to).diff(regIn));

      let hours = duration.humanize();
      // console.log(hours);
      let str = null;
      if (hours.indexOf("minutes") > 2) {
        str = hours.substr(0, 4);
      } else if (hours.indexOf("hours") > 2) {
        str = hours.substr(0, 4);
      } else if (hours.indexOf("days") > 2) {
        str = hours.substr(0, 4);
      } else if (hours.indexOf("months") > -1) {
        str = hours.substr(0, 4);
      } else if (hours.indexOf("years") > 2) {
        str = hours.substr(0, 4);
      } else {
        str = hours.substr(0, 3);
      }
      // console.log(str);
      if (str.includes("h")) {
        this.uperOrLowerH = str.includes("h");
      }
      if (str.includes("mi")) {
        this.uperOrLowerMinuts = str.includes("mi");
      }
      if (str.includes("an")) {
        str = str.replace("n", "h");
      }
      if (str.includes("a")) {
        str = str.replace("a", "1");
      }
      if (str.includes("mo")) {
        str = str.replace("mo", "M");
      }
      // console.log(str);

      return str;
    },
    getDiffByScOn(to, regIn){
      if (to && regIn) {
        let duration = moment.duration(
          moment(regIn.scheduled_on).diff(to.scheduled_on)
        );
        let hours = duration.humanize();
        let str = null;
        if (hours.indexOf("minutes") > 2) {
          str = hours.substr(0, 4);
        } else if (hours.indexOf("hours") > 2) {
          str = hours.substr(0, 4);
        } else if (hours.indexOf("days") > 2) {
          str = hours.substr(0, 4);
        } else if (hours.indexOf("years") > 2) {
          str = hours.substr(0, 4);
        } else {
          str = hours.substr(0, 3);
        }

        if (str.includes("h")) {
          this.uperOrLowerH = str.includes("h");
        }
        if (str.includes("mi")) {
          this.uperOrLowerMinuts = str.includes("mi");
        }
        if (str.includes("an")) {
          str = str.replace("n", "h");
        }
        if (str.includes("a")) {
          str = str.replace("a", "1");
        }

        return str;
      } else {
        return 0;
      }
    },
    getDiffBySc(to, regIn) {
      if (to && regIn) {
        let duration = moment.duration(
          moment(regIn.created_at).diff(to.created_at)
        );
        let hours = duration.humanize();
        let str = null;
        if (hours.indexOf("minutes") > 2) {
          str = hours.substr(0, 4);
        } else if (hours.indexOf("hours") > 2) {
          str = hours.substr(0, 4);
        } else if (hours.indexOf("days") > 2) {
          str = hours.substr(0, 4);
        } else if (hours.indexOf("years") > 2) {
          str = hours.substr(0, 4);
        } else {
          str = hours.substr(0, 3);
        }

        if (str.includes("h")) {
          this.uperOrLowerH = str.includes("h");
        }
        if (str.includes("mi")) {
          this.uperOrLowerMinuts = str.includes("mi");
        }
        if (str.includes("an")) {
          str = str.replace("n", "h");
        }
        if (str.includes("a")) {
          str = str.replace("a", "1");
        }

        return str;
      } else {
        return 0;
      }
    },
    getDiffByScAvg(arrayDiff, col) {
      let tempArr = [];
      arrayDiff.map(a => {
        tempArr.push(a[col]);
      });

      // console.log((_.last(tempArr) - tempArr[0]) / (tempArr.length - 1));
      let total = 0;
      let idxDate = null;

      arrayDiff.map((date, idx) => {
        if (idx + 1 === arrayDiff.length) {
          return;
        }
        idxDate = date[col];
        total += moment.duration(moment(idxDate).diff(arrayDiff[idx + 1][col]));
      });
      if (total) {
        total = (total / (arrayDiff.length - 1)).toFixed(0);
        total = parseInt(total);
        total = moment.duration(total);

        // total = new Date(total);
        // total = total.toUTCString();
        // total = moment(total).toDate()
        let hours = total.humanize();

        let str = null;
        if (hours.indexOf("minutes") > 2) {
          str = hours.substr(0, 4);
        } else if (hours.indexOf("hours") > 2) {
          str = hours.substr(0, 4);
        } else if (hours.indexOf("days") > 2) {
          str = hours.substr(0, 4);
        } else if (hours.indexOf("years") > 2) {
          str = hours.substr(0, 4);
        } else {
          str = hours.substr(0, 3);
        }

        if (str.includes("h")) {
          this.uperOrLowerH = str.includes("h");
        }
        if (str.includes("mi")) {
          this.uperOrLowerMinuts = str.includes("mi");
        }
        if (str.includes("an")) {
          str = str.replace("n", "h");
        }
        if (str.includes("a")) {
          str = str.replace("a", "1");
        }
        if (str) {
          return str;
        }
      }
    },
    getDiffByMissedAvg(arrayDiff, col) {
      let tempArr = [];
      arrayDiff.map(a => {
        tempArr.push(a[col]);
      });

      // console.log((_.last(tempArr) - tempArr[0]) / (tempArr.length - 1));
      let total = 0;
      let idxDate = null;
      arrayDiff.map((date, idx) => {
        if (idx + 1 === arrayDiff.length) {
          return;
        }
        idxDate = date[col];
        total += moment.duration(moment(idxDate).diff(arrayDiff[idx + 1][col]));
      });
      if (total) {
        total = (total / arrayDiff.length).toFixed(0);
        total = parseInt(total);
        total = moment.duration(total);

        // total = new Date(total);
        // total = total.toUTCString();
        // total = moment(total).toDate()
        let hours = total.humanize();

        let str = null;
        if (hours.indexOf("minutes") > 2) {
          str = hours.substr(0, 4);
        } else if (hours.indexOf("hours") > 2) {
          str = hours.substr(0, 4);
        } else if (hours.indexOf("days") > 2) {
          str = hours.substr(0, 4);
        } else if (hours.indexOf("years") > 2) {
          str = hours.substr(0, 4);
        } else {
          str = hours.substr(0, 3);
        }

        if (str.includes("h")) {
          this.uperOrLowerH = str.includes("h");
        }
        if (str.includes("mi")) {
          this.uperOrLowerMinuts = str.includes("mi");
        }
        if (str.includes("an")) {
          str = str.replace("n", "h");
        }
        if (str.includes("a")) {
          str = str.replace("a", "1");
        }
        if (str) {
          return str;
        }
      }
    }
  }
};
